import { EditorState, Plugin, PluginKey } from '@tiptap/pm/state';
import { TGateState, makePresenceGate } from '../../../plugins/shared';
import { CAPTION_NODE_NAME, isValidCaptionKind, OutRefBookmarkKind } from '../constants';
import { TCaptionMap, normalizeCaptionText } from '@shared/backendFrontend/captionHelpersFe';

const key = new PluginKey<TGateState>('caption-node-index');
const presenceGateApply = makePresenceGate(CAPTION_NODE_NAME);

const getTrackCaptionsPlugin = (onUpdate?: (m: TCaptionMap) => void) =>
  new Plugin<TGateState>({
    key,

    state: {
      init(): TGateState {
        return { updatedTime: -1 };
      },
      apply: presenceGateApply, // ← gated exactly like before, but reusable
    },

    appendTransaction(_trs, oldState, newState) {
      // @ts-expect-error – access plugin state snapshots
      if (oldState[key.key] === newState[key.key]) return null;
      if (onUpdate) onUpdate(buildCaptionsMap(newState.doc));
      return null;
    },
  });

// --- HELPERS ---
/**
 * bookmark-id → caption entry, from a ProseMirror doc.
 *
 * Exported because the large-document model needs the same map over the WHOLE document: the editor
 * holds one part, so references to a caption elsewhere would not resolve. The html-based
 * `buildCaptionsMapFe` is the counterpart for consumers that only have html (the backend, the diff).
 */
export const buildCaptionsMap = (doc: EditorState['doc']): TCaptionMap => {
  const map: TCaptionMap = {};
  doc.descendants((node) => {
    if (node.type.name === CAPTION_NODE_NAME) {
      const kind = node.attrs.bookmarkKind;
      if (!isValidCaptionKind(kind)) return true;
      const index = node.attrs.index as number;
      const content = normalizeCaptionText(node.textContent);
      map[node.attrs.id] = { index, content, kind };
    }
    return true;
  });
  return map;
};

export default getTrackCaptionsPlugin;
